'use client';

import Link from '@eliadmin/core/src/components/link';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { ROUTES_OVERRIDES } from '../../constants/routes-overrides';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function PageBreadcrumbs({
  name,
  showProducts = false,
  className,
  title,
  currentNameAsHeading = false,
}: {
  name: string;
  showProducts?: boolean;
  title?: string;
  currentNameAsHeading?: boolean;
  className?: {
    section?: string;
    container?: string;
    title?: string;
  };
}) {
  const { t } = useTranslations();

  return (
    <section
      className={cn(
        'custom-section',
        'pb-4 pt-8 sm:pb-6 sm:pt-10 lg:pb-8 lg:pt-12',
        className?.section,
      )}
    >
      <div
        className={cn(
          'custom-container',
          'flex w-full flex-col items-start justify-start gap-8',
          className?.container,
        )}
      >
        <div className="hide-scroll-bar flex w-full flex-nowrap items-center justify-start gap-1 overflow-x-scroll">
          <Link
            prefetch={false}
            href={ROUTES.HOME()}
            className="whitespace-nowrap text-sm text-accent transition-all hover:opacity-80 sm:text-base"
          >
            {t('text160')}
          </Link>
          <MdOutlineKeyboardArrowRight
            size={20}
            className="max-h-5 min-h-5 min-w-5 max-w-5 text-[#D1D1D1]"
          />
          {showProducts && (
            <>
              <Link
                prefetch={false}
                href={ROUTES_OVERRIDES.PRODUCTS()}
                className="whitespace-nowrap text-sm text-accent transition-all hover:opacity-80 sm:text-base"
              >
                {t('text150')}
              </Link>
              <MdOutlineKeyboardArrowRight
                size={20}
                className="max-h-5 min-h-5 min-w-5 max-w-5 text-[#D1D1D1]"
              />
            </>
          )}
          {currentNameAsHeading ? (
            <h1 className="whitespace-nowrap text-sm transition-all hover:opacity-80 sm:text-base">
              {name}
            </h1>
          ) : (
            <span className="whitespace-nowrap text-sm transition-all hover:opacity-80 sm:text-base">
              {name}
            </span>
          )}
        </div>
        {title && (
          <h2
            className={cn(
              'text-left text-[40px] font-medium leading-[1.1] tracking-tighter sm:text-5xl sm:leading-[1.1] xl:text-[56px] xl:leading-[1.1]',
              className?.title,
            )}
          >
            {title}
          </h2>
        )}
      </div>
    </section>
  );
}
